<template>
  <div id="app">
    <v-ons-splitter>
    <v-ons-splitter-side
       width="150px" collapse="" side="left"
      :open.sync="openSide" 
    >
      <v-ons-page>
        <v-ons-list>
          <v-ons-list-item style="font-family:'Uni Sans'; border-bottom: 2px solid"><img src="./assets/img/cadastro2.png" width="40px" style="margin-right:12px"> {{ dsNome }}</v-ons-list-item>
           <v-ons-list-item><v-ons-icon icon="fa-credit-card" style="margin-right:8px"></v-ons-icon>Minha carteira</v-ons-list-item>
          <v-ons-list-item><v-ons-icon icon="fa-gift" style="margin-right:8px"></v-ons-icon>Promoções</v-ons-list-item>
          <v-ons-list-item><v-ons-icon icon="fa-shopping-cart" style="margin-right:8px"></v-ons-icon>Histórico de compras</v-ons-list-item>
          <v-ons-list-item><v-ons-icon icon="fa-question-circle" style="margin-right:8px"></v-ons-icon>Central de ajuda</v-ons-list-item>
          <v-ons-list-item><a target="_blank" href="http://cymadigital.com.br/hnk-vending/termos-de-uso.html"><v-ons-icon icon="fa-file-alt" style="margin-right:8px"></v-ons-icon>Termos de uso</a></v-ons-list-item>
          
          <v-ons-list-item @click="doLogout()"><v-ons-icon icon="fa-sign-out-alt" style="margin-right:8px"></v-ons-icon>Sair</v-ons-list-item>
        </v-ons-list>
      </v-ons-page>
    </v-ons-splitter-side>

    <v-ons-splitter-content>
      <v-ons-navigator :page-stack="pageStack" >
        <component  v-for="page in pageStack" @push="pageStack.push($event)" @pop="pageStack.pop()" :is="page"  :key="page.name" @open-menu="() => {openSide = true}"  @change-name="(strName) => {dsNome = strName}" ></component>
      </v-ons-navigator>
    </v-ons-splitter-content>
  </v-ons-splitter>

  </div>
</template>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #fff;
  margin-top: 60px;
}
a { 
  color:#000;
  text-decoration: none;;
}
</style>

<script>
// import Login from './components/Login.vue'
import ProcessandoPedido from './components/ProcessandoPedido.vue'
import ObrigadoVue from './components/Obrigado.vue'
import GatewayVue from './components/Gateway.vue'
import FalhaVendaVue from './components/FalhaVenda.vue'

export default {
  name: 'Heineken00',
  data() { 
    return { 
      wsStatus: false,
      wsLastMassage: "",
      pageStack: [GatewayVue],
      openSide: false,
      dsNome: ""
    }
  },
  created() { 

  },
  methods: {

  },
  sockets: {
    connect: function () {
      this.wsStatus = 'socket connected';
    },
    disconnect: function() {
      this.wsStatus = 'socket disconnected'; 
    },
    usrConnect: function(data) { 
      //alert(JSON.stringify(data));
      this.$socket.emit('scanGeladeira',{ 
                          "room":data.machId, 
                          "idUser": localStorage.getItem("idCliente")
                        })
    },
    openedGeladeira: function() { 
        this.pageStack.push(ObrigadoVue)
    },
    productSelected: function(data) {
      if (data.product) { 
        this.product = data.product
        this.pageStack.splice(1, this.pageStack.length - 1)
        this.pageStack.push(ProcessandoPedido)
      }
    },
    vendSuccessful: function () {
      //this.pageStack.splice(1, this.pageStack.length - 1)
      this.$ons.notification.toast("Sua compra foi realizada com sucesso, retire seu produto na máquina! ", { timeout: 1000, animation: 'ascend' });
      this.pageStack.push(ObrigadoVue)    
    },
    vendFailed: function() {
      this.pageStack.splice(1, this.pageStack.length - 1)
      this.pageStack.push(FalhaVendaVue)    
    },
    vendPolled: function() { 
      // this.pageStack.splice(1, this.pageStack.length - 1)
      // this.pageStach.push(Mapa)
    }
  }
}
</script>
